define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Button = require("ui/button/Button");
    var Logger = require("logger");
    var BannerModel = require("ui/banner/js/models/BannerModel");
    var template = require("ui/banner/templates/banner.tmpl");
    var templateCountDownBanner = require("ui/banner/templates/countDownBanner.tmpl");
    var Counter = require("ui/counter/Counter");
    var _ = require("underscore");
    var $ = require("jquery");

    var BannerView = Marionette.ItemView.extend({
        tagName: "div",
        ui: {
            actionBtn: ".actionBtn",
            "countDown": ".countDown",
            "countDownSpinner": ".countDownSpinner"
        },
        events: {
            "click .longBanner .close": "onCloseClick"
        },
        initialize: function (options) {
            this.logger = Logger.getLogger("Banner");
            if (!this._isValidOptions(options)) {
                throw "Banner :: invalid argument: options is illegal.";
            }

            this.container = options.container || "body";
            this.permutation = options.permutation || BannerView.PERMUTATION.DEFAULT;
            this.template = this.getTemplateByPermutation();
            this.callback = options.callback || null;

            this.counterText = options.counterText || "";
            this.counterNumber = options.counterNumber || 0;
            this.onCounterDone = options.onCounterDone || false;
            this.spinnerText = options.spinnerText || "";
            this.model = new BannerModel(options);

        },

        onRender: function () {
            var permutationClass = this._setPermutationClass();
//            if (permutationClass) {
//                this.$el.children().addClass(permutationClass);
//            }
            this._renderWidgetsByPermutation();


            $(this.container).append(this.el);
        },


        _isValidOptions: function (options) {
            if (!options || !_.isObject(options)) {
                this.logger.error("invalid argument: options is illegal","BannerView:_isValidOptions");
                this.logger.graph({ name: "UIComponents:BannerView:NoValidOptions"});
                return false;
            }
//            if (!options.callback || !_.isFunction(options.callback)) {
//                this.logger.error("invalid argument: options.callback is illegal");
//                return false;
//            }

            return true;
        },

        _setPermutationClass: function () {
            var permutationClass = '';
            var permutationParentClass = '';
            switch (this.permutation) {
                case (BannerView.PERMUTATION.COUNT_DOWN):
                    permutationClass = 'bannerCountDown';
                    permutationParentClass="longBannerParent";
                    break;
                case (BannerView.PERMUTATION.COUNT_DOWN_SUCCESS):
                    permutationClass = 'bannerCountDownSuccess';
                    permutationParentClass="longBannerParent";
                    break;
                default:
                    permutationClass = null;
                    break;

            }

            if (permutationClass) {
                this.$el.children().addClass(permutationClass);
            }
            if(permutationParentClass){
                this.$el.addClass(permutationParentClass);
            }
        },
        getTemplateByPermutation: function () {
            var retTemplate;
            switch (this.permutation) {
                case (BannerView.PERMUTATION.COUNT_DOWN):
                    retTemplate = templateCountDownBanner;
                    break;
                case (BannerView.PERMUTATION.COUNT_DOWN_SUCCESS):
                    retTemplate = templateCountDownBanner;
                    break;
                default:
                    retTemplate = template;
                    break;

            }
            return retTemplate;
        },
        _renderWidgetsByPermutation: function () {
            switch (this.permutation) {
                case (BannerView.PERMUTATION.COUNT_DOWN):
                    this._renderActionBtn(Button.PERMUTATION.BTN_PRIMARY);
                    this._renderCounter();
                    break;
                case (BannerView.PERMUTATION.COUNT_DOWN_SUCCESS):

                    break;
                default:
                    this._renderActionBtn(Button.PERMUTATION.BTN_PRIMARY_MARKETING);
                    break;

            }
        },
        _renderActionBtn: function (permutation) {
            this.actionBtn = new Button({
                el: this.ui.actionBtn,
                tooltip: this.model.actionBtnTooltip,
                permutation:  permutation || Button.PERMUTATION.BTN_PRIMARY_MARKETING,
                initState: Button.STATES.ENABLED,
                onClick: this.callback
            });
            this.actionBtn.render();
        },
        _renderCounter: function () {
            this.counter = new Counter({
                "container": this.ui.countDown,
                "text": this.counterText,
                "number": this.counterNumber,
                "permutation": Counter.PERMUTATION.B,
                "minSpeed": 1000,
                "direction": Counter.DIRECTION.DOWN,
                "closeOnDone": _.bind(this._onCounterDone, this),
                "start": 1
            });
            this.counter.render();
        },
        _onCounterDone: function () {
            this._showSpinner();

            if (_.isFunction(this.onCounterDone)) {
                this.onCounterDone();
            }
        },
        onCloseClick: function () {
            this.close();
        },

        _showSpinner: function () {
            if (!this.uiClosing) {
                this.ui.countDownSpinner.addClass("countDownSpinnerDisplay");
                this.timeOutHandler = setTimeout(_.bind(this._reStartCounter, this), 4000);
            }
        },
        _reStartCounter: function () {
            this.ui.countDownSpinner.removeClass("countDownSpinnerDisplay");
            this._renderCounter();
        },
        onClose: function () {
            this.uiClosing = true;

            if (this.timeOutHandler > -1) {
                clearTimeout(this.timeOutHandler);
                this.timeOutHandler = -1;
            }
        }

    });

    BannerView.PERMUTATION = {
        DEFAULT: 1,
        COUNT_DOWN: 2,
        COUNT_DOWN_SUCCESS: 3
    };

    return BannerView;
});
